import React from "react"
import Button from "components/Forms/Button"
import useFlashMessages, { FlashMessage } from "hooks/useFlashMessages"

export interface FlashMessageListProps {
  messages?: FlashMessage[]
}

const FlashMessageList = ({ messages }: FlashMessageListProps) => {
  const { dismissFlashMessage } = useFlashMessages()

  const onMessageDismissed = async (id: number) => {
    try {
      await dismissFlashMessage({ id })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  if (!messages?.length) {
    return null
  }

  return (
    <ul className="bg-white border border-primary-light-gray rounded-lg px-4 mb-4 md:mb-6">
      {messages.map(message => (
        <li
          key={message.id}
          className="flex flex-col justify-between items-center border-t border-primary-light-gray py-4 first:border-t-0 md:flex-row"
        >
          <div className="mb-4 md:mb-0">
            <h3 className="font-medium mb-1">{message.title}</h3>

            <p
              className="text-sm text-primary-dark-gray"
              dangerouslySetInnerHTML={{ __html: message.message }}
            />
          </div>

          <Button
            variant="secondary"
            onClick={() => onMessageDismissed(message.id)}
            className="w-full flex-shrink-0 md:ml-4 md:w-auto"
            data-testid="mark-as-read"
          >
            Mark as read
          </Button>
        </li>
      ))}
    </ul>
  )
}

export default FlashMessageList
